// Copyright (c) 2025 Audere, All Rights Reserved

import { Box } from "@mui/material";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import statusLoader from "../../assets/status_loader.svg";
import { theme } from "../../theme";
import { createStyleSheet } from "../utils/styles";
import { LABELING_STATUS, TEST_STATUS, type GetStatusIcon } from "../types/projects";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

export const getStatusIcon = (status?: GetStatusIcon) => {
  switch (status) {
    case LABELING_STATUS.COMPLETE:
    case TEST_STATUS.SUCCESS:
      return <CheckCircleOutlineIcon sx={styles.completeStatus} />;

    case TEST_STATUS.IN_PROGRESS:
      return <Box component="img" src={statusLoader} alt="Loading" sx={styles.statusLoader} />;
    case TEST_STATUS.FAILURE:
      return <ErrorOutlineIcon color="error" />;
    case TEST_STATUS.NOT_AVAILABLE:
    default:
      return <Box sx={styles.notStartedStatus} />;
  }
};

const styles = createStyleSheet({
  statusLoader: { width: 20, height: 20, mr: 1.5 },
  completeStatus: { color: theme.palette.success.main },
  notStartedStatus: {
    width: 20,
    height: 20,
    borderRadius: "50%",
    backgroundColor: theme.palette.grey[300],
    mr: 1.5,
  },
});
